import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Carrot2App } from "./carrot2/Carrot2App.js";
import * as serviceWorker from "./serviceWorker.js";

ReactDOM.render(<Carrot2App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
